import React from "react";
import { TextField, TextFieldProps } from "@mui/material";
import { applyPhoneMask, isValidPhone } from "../../utils";

interface PhoneInputProps extends Omit<TextFieldProps, "onChange"> {
  value: string;
  onChange: (value: string) => void;
}

const PhoneInput: React.FC<PhoneInputProps> = ({
  value,
  onChange,
  ...textFieldProps
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const maskedValue = applyPhoneMask(inputValue);
    onChange(maskedValue);
  };

  // Determina se deve mostrar erro
  const shouldShowError =
    textFieldProps.error !== undefined ? textFieldProps.error : false;
  const hasValue = value.trim().length > 0;
  const isInvalid = hasValue && !isValidPhone(value);

  // Só mostra erro automático se não houver erro customizado
  const showAutoError = !shouldShowError && isInvalid;

  return (
    <TextField
      {...textFieldProps}
      value={value}
      onChange={handleChange}
      placeholder="(11) 99999-9999"
      error={shouldShowError || showAutoError}
      helperText={
        showAutoError
          ? "Telefone deve ter 11 dígitos (DDD + 9 dígitos)"
          : textFieldProps.helperText
      }
      inputProps={{
        maxLength: 15,
        inputMode: "numeric",
        ...textFieldProps.inputProps,
      }}
    />
  );
};

export default PhoneInput;
